<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="项目名称:" prop="strDocumentTitle">
        <el-input v-model.trim="searchForm.strDocumentTitle" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="data" label="操作" width="80" align="left" fixed="left">
          <template v-slot="{ row }">
            <el-button type="text" @click="goDoIt(row)">
              办理
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="orderName" label="项目名称" align="left" min-width="100" />
        <el-table-column
          prop="agentName"
          label="集成商名称"
          align="left"
          min-width="100"
        />
        <el-table-column
          prop="processClass"
          label="流程分类"
          align="left"
          min-width="100"
        />
        <el-table-column
          prop="salesmanName"
          label="销售人员"
          align="left"
          min-width="90"
        />
        <el-table-column
          prop="finalCustomerName"
          label="最终客户名称"
          align="left"
          min-width="100"
        />
        <el-table-column
          prop="orderCreateTime"
          label="订单时间"
          align="left"
          width="140"
        />
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getPreferredOrderToDoList } from '../../../../API/index';
import eventBus from '@/libs/eventBus';
export default {
  data () {
    return {
      searchForm: {
        strDocumentTitle: ''
      },
      tableData: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      needLoadData: false
    };
  },
  components: {},
  computed: {
  },
  methods: {
    doSearch () {
      this.tableLoading = true;
      getPreferredOrderToDoList({
        orderName: this.searchForm.strDocumentTitle,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200' && json.data.dt) {
          this.tableData = json.data.dt;
          this.page.currentPage = json.data.pageIndex;
          this.page.total = json.data.totalCount;
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    async goDoIt (row) {
      this.$router.push({
        name: 'FirstDistributorOrder',
        params: {
          documentId: row.documentId
        }
      });
    }
  },
  mounted () {
    this.doSearch();
    eventBus.$on('CompleteDistrOrder', () => {
      this.needLoadData = true;
    });
  },
  activated () {
    if (this.needLoadData) {
      this.doSearch();
    }
  },
  destroyed () {
    eventBus.$off('CompleteDistrOrder');
  }
};
</script>
<style lang="scss"></style>
